var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{on:{"click":function($event){_vm.active = !_vm.active}}},[_vm._v("Edit")]),_vm._v(" "+_vm._s(_vm.active)+"\n  "),(_vm.active)?_c('editmap',{attrs:{"data":_vm.data}}):_c('viewmap',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }